import React from "react";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@material-ui/core";
import { Club } from "api/clubs";
import moment from "moment";
import i18n from "../i18n";

// prop types
interface CourtPickerProps {
    club: Club | null,
    court: string,
    error: string | null,
    onChange: (court: string) => void,
}

// duration picker form element
const CourtPicker = ({ club, court, error, onChange }: CourtPickerProps) => {
    // format open times
    const courtObject = club?.courts.find((c) => c.id === court);
    const openTime = moment().dayOfYear(1).startOf("day").add(courtObject?.openTimeMins, "minutes").format("H:mm");
    const closeTime = moment().dayOfYear(1).startOf("day").add(courtObject?.closeTimeMins, "minutes").format("H:mm");

    // relevant errors
    const relevantErrors = ["courtIsBooked", "outOfOpeningHours"];
    const getHelperText = () => {
        if (error === "courtIsBooked") return i18n.courtOccupied;
        return `${i18n.opened} ${openTime} - ${closeTime}`;
    };

    const sortedCourt = club && [...club.courts];
    sortedCourt?.sort((a, b) => a?.courtNumber - b?.courtNumber);

    // render
    return (
        <FormControl error={relevantErrors.includes(error!)} fullWidth variant="outlined">
            <InputLabel>{i18n.court}</InputLabel>
            <Select
                label={i18n.court}
                value={court}
                onChange={(e) => onChange(e.target.value as string)}
            >
                {sortedCourt?.map((c) => (
                    <MenuItem key={c.id} value={c.id}>{c.courtName}</MenuItem>
                ))}
            </Select>
            <FormHelperText error={relevantErrors.includes(error!)}>{getHelperText()}</FormHelperText>
        </FormControl>
    );
};

export default CourtPicker;
